export const URLS = {
  SUBSCRIPTION: 'api/v1/subscription-data',
  PROFILE: 'api/v1/profile',
  CONVERSATION: 'api/v1/genai',
  WORKFLOW: 'api/v1/workflow',
  PROCESS: 'api/v1/process',
  UPLOAD_FILE: 'api/v1/file/upload',
  DELETE_FILE: 'api/v1/file/delete',
};
